<style lang="scss" scoped>
  @import "~bootstrap/scss/vendor/rfs";

  .card-info-role {
    min-height: 198px;

    > .role-name {
      color: #3b334a;
      font-family: "Montserrat";
      @include font-size(16px);
      font-weight: 400;
      letter-spacing: -0.24px;
      line-height: 25px;
    }
    > ul.role-attributes {
      list-style: none;
      padding: 0;
      margin: 1.1875rem 0 0 0;

      > .attribute {
        color: #3b334a;
        font-family: Montserrat;
        @include font-size(13px);
        font-weight: 400;
        letter-spacing: -0.2px;
        line-height: 25px;

        > span {
          display: block;
          font-weight: 500;
        }
      }
    }

    > .actions-area {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      box-shadow: 0 5px 20px rgba(165, 131, 224, 0.15);
      border-radius: 0 0 15px 15px;
      background-color: #f6f5f8;
      height: 0;
      align-items: center;
      display: flex;
      flex: 0;
      padding: 0 1.875rem;
      overflow: hidden;
      transition: all 150ms;

      > .btn {
        background-color: #2ceba9;
        border-radius: 23px;
        color: #130f19;
        font-family: "Montserrat";
        @include font-size(14px);
        font-weight: 400;
        border: 0;
        padding: 9px 23px;
      }

      .icon {
        color: #3b334a;
        @include font-size(18px);
        background-color: transparent;
        border: 0;
      }
    }

    &:hover {
      > .actions-area {
        flex: 1;
        height: 88px;
      }
    }
  }
</style>

<template>
  <div class="card card-info-role">
    <div class="role-name">
      {{ name }}
    </div>
    <ul class="role-attributes">
      <li class="attribute">
        <span>{{ __('Cadastro') }}:</span> {{ createdAt }}
      </li>
      <li class="attribute">
        <span>{{ __('Última atualização') }}:</span> {{ updatedAt }}
      </li>
    </ul>
    <form
      class="actions-area"
      method="POST"
      :action="hrefDestroy"
      accept-charset="UTF-8"
      ref="formDestroy"
    >
      <input
        name="_method"
        type="hidden"
        value="DELETE"
      >
      <input
        name="_token"
        type="hidden"
        :value="csrf"
      ><a
        class="btn btn-success"
        :href="href"
      >{{ __('Ver mais') }}</a>
      <button
        class="icon ml-auto"
        @click="destroy"
        type="button"
      >
        <i class="fa fa-trash-o" />
      </button>
    </form>
  </div>
</template>

<script>
import { Confirm } from '../../services/Confirm';

export default {
  name: 'CardInfoUser',

  props: {
    name: {
      type: String,
      required: true,
    },
    createdAt: {
      type: String,
      required: true,
    },
    updatedAt: {
      type: String,
      required: false,
      default: '',
    },
    href: {
      type: String,
      required: true,
    },
    hrefDestroy: {
      type: String,
      required: true,
    },
  },

  data () {
    const csrf = document.querySelector('#csrf-token');

    return {
      csrf: csrf ? csrf.getAttribute('content') : '',
    };
  },

  methods: {
    async destroy () {
      if (await Confirm(this.__('Deseja excluir o grupo?'))) {
        this.$refs.formDestroy.submit();
      }
    },
  },
};
</script>
